export default function isValidIP(ip) {
  const res =
    /^(((25[0-5]|(2[0-4]|[01]\d|\d|)\d)\.?\b){4}|(([a-f0-9:]+:+)+[a-f0-9]+)(::)?)$/;
  return ip ? res.test(ip.trim()) : false;
}
